import { useState, useEffect } from 'react';
import  {Box, Button, TextField } from '@mui/material';
import IconCancel from '@mui/icons-material/Cancel';
import dataProvider from '../../lib/dataProvider';
import 'moment/dist/locale/de';

const FindGuest = ({setFindguest, selGuest}) => {
  const [filter, setFilter] = useState({});
  const [guests, setGuests] = useState([]);

  useEffect(() => {
    dataProvider.getList('appFindguest', {filter, sort: { field: 'name', order: 'ASC' }, pagination: { page: 1, perPage: 20 }, })
    .then((res) => {
      setGuests(res.data);
    });
  }, [filter]);

  const setFilterValue = (key) => (ev) => {
    setFilter({...filter, ...{[key]: ev.target.value}});
  }
  console.log(['filter', filter])
  return (
    <Box sx={{padding:'1em', border:'1px solid #333', borderRadius:'5px', marginBottom:'1em', position:'relative'}}>
      <Button label="ra.action.cancel" onClick={()=>setFindguest(false)} sx={{position:'absolute', right:'-1em', top:'0'}}><IconCancel /></Button>
      <TextField label="Firstname" value={filter.vorname} onChange={setFilterValue('vorname')} />
      <TextField label="Lastname" value={filter.name} onChange={setFilterValue('name')} />
      <table>
        <tbody>
  {guests.map((g, k) => (
            <tr key={k} onClick={selGuest(g.id)} className="clickable">
              <td>{g.vorname}</td>
              <td>{g.name}</td>
              <td>{g.land}</td>
            </tr>
  ))}
        </tbody>
      </table>
    </Box>
  );
}

export default FindGuest;